export default "__VITE_PUBLIC_ASSET__7ea3ae83__"